/// <amd-module name="Wit/Settings/BoardsExternalIntegration/components/panels/orgSelection/OrgPicker" />
import * as React from "react";
import { VssComponent } from "VSS/Platform/Layout";
import { IListItemDetails, IListRow, ListItem, ListSelection, ScrollableList } from "VSSUI/List";
import { ArrayItemProvider } from "VSSUI/Utilities/Provider";
import { VssPersona } from "VSSUI/VssPersona";
import { GitHubOrgOrUser } from "Wit/Clients/Internal/Contracts/WorkItemTracking";
import { IOrgPickerProps } from "Wit/Settings/BoardsExternalIntegration/components/panels/orgSelection/OrgPicker.Props";

export class OrgPicker extends VssComponent<IOrgPickerProps> {
    public render(): JSX.Element {
        const { orgList } = this.props;

        const items = orgList && new ArrayItemProvider(orgList);
        const listSelection = new ListSelection();
        return (
            <div className="org-selection">
                <ScrollableList
                    itemProvider={items}
                    renderRow={this.renderRow}
                    selection={listSelection}
                    width="100%"
                    singleClickActivation={true}
                    onActivate={this._onActivated}
                />
            </div>
        );
    }

    private renderRow = (index: number, item: GitHubOrgOrUser, details: IListItemDetails<GitHubOrgOrUser>, key?: string): JSX.Element => {
        return (
            <ListItem key={"list-item-" + index} index={index} details={details}>
                <div className="org-list-details flex-row flex-center">
                    <VssPersona
                        identityDetailsProvider={{
                            getIdentityImageUrl: (size: number): string | undefined => {
                                return item.avatarUrl;
                            },
                            getDisplayName: (): string => {
                                return item.name;
                            }
                        }}
                        size={"medium-plus"}
                    />
                    <div className="org-name">{item.name}</div>
                </div>
            </ListItem>
        );
    };

    private _onActivated = (event: React.SyntheticEvent<HTMLElement>, listRow: IListRow<GitHubOrgOrUser>): void => {
        this.props.onSelectedOrgChanged && this.props.onSelectedOrgChanged(listRow.data);
    };
}
